import React, { useState, useEffect } from "react";
import { setLanguage, getLanguage } from "./i18n";

const LanguageSelector: React.FC = () => {
  const [selectedLanguage, setSelectedLanguage] = useState<string>(getLanguage());

  useEffect(() => {
    setSelectedLanguage(getLanguage()); 
  }, []);

  const handleLanguageChange = (lang: string) => {
    setLanguage(lang as any);
    setSelectedLanguage(lang);
    window.location.reload(); 
  };

  return (
    <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
      <select value={selectedLanguage} onChange={(e) => handleLanguageChange(e.target.value)}>
        <option value="en">English</option>
        <option value="es">Español</option>
      </select>
    </div>
  );
};

export default LanguageSelector;
